import { isLocalHost } from '../../../helpers/environmentHelper';

export type AssistantAgentType = 'call' | 'chat';

// The assistant is an ordinary Elora chat agent (one per agent type, per
// environment) provisioned on the backend; its app ID is injected at build
// time. Empty when not configured, which leaves the call assistant step out
// of the form (see getAgentStepOrder).
export const getAgentCreationAssistantAppId = (
  agentType: AssistantAgentType
): string => {
  const appId =
    agentType === 'call'
      ? isLocalHost()
        ? process.env.REACT_APP_SBX_AGENT_CREATION_CALL_ASSISTANT_APP_ID
        : process.env.REACT_APP_PRD_AGENT_CREATION_CALL_ASSISTANT_APP_ID
      : isLocalHost()
        ? process.env.REACT_APP_SBX_AGENT_CREATION_CHAT_ASSISTANT_APP_ID
        : process.env.REACT_APP_PRD_AGENT_CREATION_CHAT_ASSISTANT_APP_ID;
  return appId ?? '';
};

interface AgentCreationChatUrlParams {
  host: string;
  appId: string;
  publicKey: string;
  parentOrigin: string;
  agentType: AssistantAgentType;
}

// URL of the chat widget rendered as a full-width in-app panel, rather than
// the floating bubble that chatbot.js mounts.
export const buildAgentCreationChatUrl = ({
  host,
  appId,
  publicKey,
  parentOrigin,
  agentType,
}: AgentCreationChatUrlParams): string | null => {
  if (!appId) return null;

  const params = new URLSearchParams({
    appId,
    publicKey,
    parent: parentOrigin,
    mode: 'agent_creation',
    agentType,
    fullWidth: 'true',
    noBackground: 'true',
    hideClearButton: 'true',
  });
  return `${host.replace(/\/+$/, '')}/?${params.toString()}`;
};
